module.exports = __webpack_public_path__ + "static/img/logo_20260828.20a7a843.svg";